import React from 'react';
import { useQuery } from '@apollo/client';
import { GetViewerLearningDetailsDocument } from '@sandtech-hub-monorepo/ehub-client';
import { Loading } from '@sandtech-hub-monorepo/ui-kit-site';
import { HomeNotEnrolled } from './sections/HomeNotEnrolled';
import { HomeEnrolled } from './sections/HomeEnrolled';
import { getDisplayableEnrollments } from './utils';

/**
 * Learner-facing degree home, routed at
 * `AppRoutesPaths.Undergraduate` and reached from the program-path chooser.
 * Its inner links (ProgramsPreview) still point at the shared Programs /
 * Program / Learning routes, which now render the GSA surfaces.
 */
export const DegreeHome = () => {
  const { data } = useQuery(GetViewerLearningDetailsDocument, {
    fetchPolicy: 'cache-first',
  });

  if (!data) {
    return <Loading />;
  }

  const displayableEnrollments = getDisplayableEnrollments(
    data.viewer.programEnrollments ?? []
  );
  return displayableEnrollments.length ? <HomeEnrolled /> : <HomeNotEnrolled />;
};
